import { RouteConfig } from 'vue-router';

import { PREFIX_IN_BROWSER_TAB } from '@/common/platform-configuration/global-variables';

const authenticationPage = () => import('./page/AuthenticationPage.vue');
const resetPasswordPage = () => import('./page/ResetPasswordPage.vue');
const activateUserPage = () => import('./page/ActivateUserPage.vue');

import { makeTokenCheckerGuard, AuthRouteMeta, ResetPasswordService, ActivateUserService } from './services';
import { AuthenticationRouteNames } from './route-definitions';
import { InstantLoginRedirectionService } from '@/authentication/services/instant-login-redirection';
import { verifyLoginSsoStatus } from '@/authentication/services/login-sso-handler';
import store from '@/main/baseStore';

const checkIfCorrectActivateTokenPassed = makeTokenCheckerGuard(ActivateUserService.verifyToken);
const checkIfCorrectResetTokenPassed = makeTokenCheckerGuard(ResetPasswordService.verifyToken);

const routes: RouteConfig[] = [
    {
        name: AuthenticationRouteNames.LOGIN,
        path: '/login',
        meta: {
            title: `${PREFIX_IN_BROWSER_TAB} | Login`,
            onlyUnauthorized: true,
        } as AuthRouteMeta,
        component: authenticationPage,
        beforeEnter: verifyLoginSsoStatus,
    },
    {
        name: AuthenticationRouteNames.RESET_PASSWORD,
        path: '/reset-password',
        meta: {
            title: `${PREFIX_IN_BROWSER_TAB} | Reset password`,
        },
        component: resetPasswordPage,
        beforeEnter: checkIfCorrectResetTokenPassed,
    },
    {
        name: AuthenticationRouteNames.ACTIVATE_USER,
        path: '/activate-user',
        meta: {
            title: `${PREFIX_IN_BROWSER_TAB} | Setup account`,
        },
        component: activateUserPage,
        beforeEnter: checkIfCorrectActivateTokenPassed,
    },
    {
        name: AuthenticationRouteNames.INSTANT_LOGIN,
        path: '/instant-login',
        meta: {
            title: `${PREFIX_IN_BROWSER_TAB} | Login`,
        },
        redirect: route => {
            const instantLoginService = new InstantLoginRedirectionService(store);
            return instantLoginService.redirect(route);
        },
    },
];

export default routes;
